// START CODE ADDED BY VIDEOWISE TEAM TO FIX PRODUCT WIDGET
var elements = document.querySelectorAll(".product__slide");
var observer = new MutationObserver(function (event) {
  var videos = document.querySelectorAll("video");
  for (let i = 0; i < videos.length; i++) {
    videos[i].pause();
  }
  var currentSlide = document.querySelector(".slick-active");
  for (const child of currentSlide.children) {
    if (child.classList.contains("vw-product-widgets-container") === true) {
      var productWidgetVideo = currentSlide.querySelector("video");
      productWidgetVideo.play();
    }
  }
});

var productPhotosEl = document.querySelector(
  ".product__photos.product__photos--beside"
);
var observer2 = new IntersectionObserver(function (entries) {
  if (entries[0].isIntersecting === false) {
    var videosEl = productPhotosEl.querySelectorAll("video");

    for (var i = 0; i < videosEl.length; i++) {
      videosEl[i].pause();
    }
  }
}, {});
observer2.observe(productPhotosEl);

elements.forEach((e) => {
  observer.observe(e, {
    attributes: true,
    attributeFilter: ["class"],
    childList: false,
    characterData: false,
  });
});
// END CODE ADDED BY VIDEOWISE TEAM TO FIX PRODUCT WIDGET
